module.exports = __webpack_public_path__ + "static/media/25 colors deal.66dd3572.png";